'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIZE_MAP = {
	xsmall: 'size15',
	small: 'size25',
	medium: 'size35',
	large: 'size60',
	xs: 'size15',
	sm: 'size25',
	md: 'size35',
	lg: 'size60'
};

var Spinner = function (_React$Component) {
	_inherits(Spinner, _React$Component);

	function Spinner() {
		_classCallCheck(this, Spinner);

		return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
	}

	_createClass(Spinner, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    className = _props.className,
			    bsSize = _props.bsSize;

			// in the event they give a bsSize not in the map, choose the default

			var size = SIZE_MAP[bsSize] || 'size15';
			return _react2.default.createElement(
				'span',
				{ className: (0, _classnames2.default)('axui', 'spinner', className) },
				_react2.default.createElement('span', { className: size + ' circle' })
			);
		}
	}]);

	return Spinner;
}(_react2.default.Component);

Spinner.propTypes = {
	/**
  * The class name to apply to the badge.
  */
	className: _propTypes2.default.string,

	/**
  * The size of the spinner to render.
  */
	bsSize: _propTypes2.default.oneOf(['xsmall', 'xs', 'small', 'sm', 'medium', 'md', 'large', 'lg'])
};

Spinner.defaultProps = {
	bsSize: 'xsmall'
};

var _default = Spinner;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(SIZE_MAP, 'SIZE_MAP', 'src/components/Spinner.jsx');

	__REACT_HOT_LOADER__.register(Spinner, 'Spinner', 'src/components/Spinner.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/Spinner.jsx');
}();

;